import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';

import styled from '@emotion/styled';

import Button from 'Components/LegacyButton';
import Spacer from 'Components/Spacer';
import { breakpoints } from 'Components/ThemeProvider';
import Typography from 'Components/Typography';

import { srcOrNextImageProp } from 'PropTypes/imageProps';

import useMedia from 'utils/useMedia';

const Root = styled.section`
  display: grid;
  grid-template-columns: 1fr;
  ${props => props.theme.breakpoints.up('md')} {
    grid-template-columns: 1fr 1fr;
    border-top: 1px solid;
    border-bottom: 1px solid;
  }
`;

const ImgContainer = styled.div`
  width: 100%;
  border-bottom: 1px solid;

  ${props => props.theme.breakpoints.up('md')} {
    border-right: 1px solid;
    border-bottom: none;
  }
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 64px 24px;
  ${props => props.theme.breakpoints.up('sm')} {
    max-width: 650px;
  }
  ${props => props.theme.breakpoints.up('md')} {
    font-size: 48px;
    line-height: 56px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 124px;
  }
  ${props => props.theme.breakpoints.up('lg')} {
    max-width: 750px;
  }
`;

const Img = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
`;

const StyledBodyText = styled(Typography)`
  ${props => props.theme.breakpoints.match('sm')} {
    font-size: 16px;
  }
`;

const StyledTitle = styled(Typography)`
  ${props => props.theme.breakpoints.up('md')} {
    font-size: 48px;
    line-height: 56px;
  }
`;

const AboutUs = ({ content }) => {
  const { title, description, cta, imageDesktop, imageMobile } = content;
  const isMobile = useMedia(`(max-width: ${breakpoints.sm}px)`);

  return (
    <Root>
      <ImgContainer>
        <Img alt="About us" src={isMobile ? imageMobile.src : imageDesktop.src} />
      </ImgContainer>
      <TextContainer>
        <StyledTitle align="left" variant="h1">
          {title}
        </StyledTitle>
        <Spacer size={24} />
        <StyledBodyText align="left" variant="p1">
          {description}
        </StyledBodyText>
        <Spacer size={24} />
        <Button
          Component={Link}
          data-click="about"
          data-from="block-philosophy"
          to="/about"
          variant="underlinedBlack"
        >
          {cta}
        </Button>
      </TextContainer>
    </Root>
  );
};

AboutUs.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.element.isRequired,
    cta: PropTypes.string.isRequired,
    imageDesktop: srcOrNextImageProp,
    imageMobile: srcOrNextImageProp,
  }).isRequired,
};

export default AboutUs;
